import React, { useEffect, useRef } from "react";
import "./style.css";

const TriangleBackground = ({ mode, children }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    let width = (canvas.width = window.innerWidth);
    let height = (canvas.height = window.innerHeight);

    const points = [];
    const spacing = 100;
    for (let x = 0; x < width; x += spacing) {
      for (let y = 0; y < height; y += spacing) {
        points.push({
          x: x + Math.random() * 20,
          y: y + Math.random() * 20,
          dx: (Math.random() - 0.5) * 0.5,
          dy: (Math.random() - 0.5) * 0.5,
        });
      }
    }

    const draw = () => {
      ctx.clearRect(0, 0, width, height);

      ctx.strokeStyle =
        mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)";
      ctx.lineWidth = 1;

      points.forEach((p) => {
        p.x += p.dx;
        p.y += p.dy;
        if (p.x < 0 || p.x > width) p.dx *= -1;
        if (p.y < 0 || p.y > height) p.dy *= -1;
      });

      for (let i = 0; i < points.length; i++) {
        for (let j = i + 1; j < points.length; j++) {
          const dist = Math.hypot(
            points[i].x - points[j].x,
            points[i].y - points[j].y
          );
          if (dist < 150) {
            ctx.beginPath();
            ctx.moveTo(points[i].x, points[i].y);
            ctx.lineTo(points[j].x, points[j].y);
            ctx.stroke();
          }
        }
      }

      requestAnimationFrame(draw);
    };

    draw();

    const handleResize = () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [mode]);

  return (
    <div className="triangle-background-full">
      <canvas ref={canvasRef} className="triangle-canvas-full"></canvas>

      {/* Fade overlay around the edges */}
      <div
        className={`triangle-fade-overlay-full ${
          mode === "dark" ? "fade-dark" : "fade-light"
        }`}
      ></div>

      {/* Content with left-to-right fade */}
      <div
        className={`triangle-content-full ${
          mode === "dark" ? "text-dark" : "text-light"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default TriangleBackground;
